/**
 * Default error message when file type is not supported
 */
export const DEFAULT_FILE_TYPE_ERROR = "File type not supported";

/**
 * Default error message when file exceeds the maximum size
 */
export const FILE_TOO_LARGE_ERROR = "File is too large";

/**
 * Default error message when multiple files are uploaded but not allowed
 */
export const MULTIPLE_FILES_ERROR = "Multiple files are not supported";

/**
 * Default message for UTF-8 encoding requirement
 */
export const UTF8_ENCODING_REQUIREMENT = "UTF-8 encoding required";

/**
 * Default drag and drop instruction text
 */
export const DRAG_DROP_INSTRUCTION =
  "Drag and drop your file, or click here to upload";
